exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Category-module__wrapper___1ELKl{transition:.2s}.Category-module__wrapper___1ELKl.Category-module__single-item___2ZdnR{grid-row:1;grid-column:1}.Category-module__wrapper___1ELKl.Category-module__active___1ROqF{display:block}.Category-module__wrapper___1ELKl.Category-module__hidden___3uryN{display:none}", ""]);

// exports
exports.locals = {
	"wrapper": "Category-module__wrapper___1ELKl",
	"single-item": "Category-module__single-item___2ZdnR",
	"active": "Category-module__active___1ROqF",
	"hidden": "Category-module__hidden___3uryN"
};